import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Materials.frontend.types'

@Injectable({ providedIn: 'root' })
export class Materials_is_material_deletable_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { material_ids: number[] }): Promise<{ reason?: string, have_lines?: number[], have_tasks?: number[], have_contents?: number[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.material_ids)) {
      missingRequiredInParams.push('\'material_ids\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/functions/is_material_deletable_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

